import { CollabSendableSelection } from '@livekatsomo/models';
import { Selection } from 'prosemirror-state';
import { isNodeSelection } from './isNodeSelection';
import { isAllSelection } from './isAllSelection';

/**
 * Returns a sendable representation of the given selection.
 *
 * @param selection The selection to convert to a sendable format.
 * @returns A sendable representation of the selection.
 */

export function getSendableSelection(
  selection: Selection,
): CollabSendableSelection {
  /**
   * <kbd>CMD + A</kbd> triggers a AllSelection
   * <kbd>escape</kbd> triggers a NodeSelection
   */
  return {
    type: 'textSelection',
    anchor: selection.anchor,
    head:
      isAllSelection(selection) || isNodeSelection(selection)
        ? selection.head - 1
        : selection.head,
  };
}
